// extracted by mini-css-extract-plugin
export default {"editTemplatesLink":"_1Y1o_zkzCAGXUDj9Gy8_qv","is-toggled":"f-FucV02WLpUbGWUPxWlx"};